<template>
  <!-- <v-container> -->
    <div class="home">
      <v-img
          src="https://www.clker.com/cliparts/Y/l/P/U/K/D/talking-bubble-no-shadow-md.png"
          style="object-fit: scale-down; height: 42vh; width: 50vh; position: absolute; right: 27vw; top: 15vh; -webkit-transform: scaleX(-1); transform: scaleX(-1);z-index: 3;"
        ></v-img>
        <v-img
          src="https://images.template.net/79088/Free-Single-Person-Vector-1.jpg"
          style="object-fit: scale-down; max-height: 40vh; max-width: 25vw; position: absolute; right: 5vw; bottom: 10vh; z-index: 2;"
        ></v-img>
      <div class="home2">
        <v-col cols="12" lg="12" v-for="page in usedPP" :key="page.id" :style="pagenr == page.id ? '' : 'height: 0px; margin: 0px; padding: 0px; display: none'">
          <!-- <power-point-page v-if="(progress == page.id)"  -->
          <power-point-page v-if="(pagenr == page.id)" 
            :PowerpointPage="page" :TotalPages="usedPP.length"
          />
        </v-col>

        <!-- <div style="position: fixed; bottom: 30px; left: 40px;">
          <v-btn dark fab large :disabled="(progress == 0)" class="ma-2 white--text pa-5" @click="(progressCalc(-1))" elevation="5" style="filter: drop-shadow(0px 0px 0px #000);">
            Terug
          </v-btn>
          <v-btn dark fab large :disabled="(progress == usedPP.length - 1)" class="ma-2 white--text pa-5" @click="(progressCalc(1))" elevation="5" style="margin-left: 20px; filter: drop-shadow(0px 0px 0px #000);">
            Verder
          </v-btn>
        </div> -->
        <div style="position: fixed; bottom: 30px; right: 40px;">
          <h1>{{ this.pagenr + 1 }} / {{ usedPP.length }}</h1>
          <!-- <h1>{{ progress + 1 }} / {{ usedPP.length }}</h1> -->
        </div>
      </div>
    </div>
  <!-- </v-container> -->
</template>
  
<script>
import PowerPointPage from '@/components/ConvContent.vue'  
import Powerpoint1 from '@/assets/json/ConvBoundaries.json'
import Powerpoint2 from '@/assets/json/ConvAppreciate.json'
import store from '@/store'

export default {
  name: 'Powerpoint',
  components: {
    PowerPointPage
  },
  data() {
    return{
    progress: 0,
    PPid: this.$route.params.powerpointId,
    PPurl: this.$route.params.powerpointURL,
    alles: this.$route.params.alles,
  //   powerpoint: Powerpoint.powerpoint
    powerpoint1: Powerpoint1.powerpoint,
    powerpoint2: Powerpoint2.powerpoint,
    // powerpoint3: Powerpoint3.powerpoint,
    // powerpoint4: Powerpoint4.powerpoint,
    // powerpoint5: Powerpoint5.powerpoint,
    usedPP: null,
    }
  },
  created() {
    if (this.PPid == 0){
      this.usedPP = this.powerpoint1
    } else if (this.PPid == 1) {
      this.usedPP = this.powerpoint2
    } else if (this.PPid == 2) {
      this.usedPP = this.powerpoint3
    } else if (this.PPid == 3) {
      this.usedPP = this.powerpoint4
    } else if (this.PPid == 4) {
      this.usedPP = this.powerpoint5
    }
  },
  computed: {
    pagenr () {
      return store.state.page
    },
    answer(){
      return store.state.answer
    }
  },
  methods:{
    progressCalc(x){
      if (x == 1){
        // Verander deze vergelijking als er meer pagina's bij komen!!!!
        if (this.progress == this.usedPP.length){
          console.log("blijft zelfde")
        }else{
          this.progress = this.progress + 1
        }
      }else{
        if (this.progress == 0){
          console.log("blijft zelfde")
        }else{
          this.progress = this.progress - 1
        }
      }
    },
  }
}
</script>
  
<style lang="scss" scoped>
.home {
  padding-top: 30px;
  position: relative;
  display: flex;
  // justify-content: center;
  // align-items: center;
  flex-direction: column;
  height: 95vh;
  // background-color: #1d282d;
  // background-color: #156680;
  // background-color: #ffe6d9;
  background-color: #ffebcc;
  // font-family: Roboto;
  overflow: hidden;
  // text-align: center;

  .home2{
    z-index: 9;
  }
  
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 50%;
    min-width: 300vw;
    min-height: 300vw;
    background-color: rgb(255, 255, 255);
    animation-name: rotate;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  
  &:before {
    bottom: 24vh;
    border-radius: 43%;
    animation-duration: 15s;
  }
  
  &:after {
    bottom: 17vh;
    opacity: .5;
    border-radius: 47%;
    animation-duration: 15s;
  }
}

@keyframes rotate {
  0% {transform: translate(-50%, 0) rotateZ(0deg);}
  50% {transform: translate(-50%, -2%) rotateZ(180deg);}
  100% {transform: translate(-50%, 0%) rotateZ(360deg);}
}
</style>